import { Analytics, GTM } from "@miro-site/analytics";
var analytics = new Analytics();
var getAnalytics = function() {
    if (!analytics.isPrepared) {
        var providers = [];
        if (process.env.NEXT_PUBLIC_ANALYTICS_GTM_ID) {
            providers.push(new GTM(process.env.NEXT_PUBLIC_ANALYTICS_GTM_ID, process.env.NEXT_PUBLIC_ANALYTICS_GTM_AUTH || "", "env-5", "x", "dataLayer", {}, {}));
        }
        analytics.prepare(providers);
    }
    return analytics;
};
export default getAnalytics;
